type FilterType = 'alphabetical' | 'newest' | 'oldest';

export const sortProjects = (a: any, b: any, filterType: FilterType) => {
  switch (filterType) {
    case 'alphabetical':
      return a.title.localeCompare(b.title);
    case 'newest':
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    case 'oldest':
      return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    default:
      return a.id - b.id;
  }
};
